import React from "react";
import { toastr } from "react-redux-toastr";
import { useAuth0 } from "@auth0/auth0-react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { DialogActions, CircularProgress } from "@material-ui/core";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
// component
import MyButton from "components/MyButton/index";
import PastoralService from "Lib/API/PastoralApi/index";

const EditEventDescriptionModal = ({
  open,
  initialDescription,
  onClose,
  eventId,
  refetchEventCallback,
}) => {
  const { getAccessTokenSilently } = useAuth0();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Event Description</DialogTitle>

      <Formik
        initialValues={{ description: initialDescription || "" }}
        onSubmit={async (values, { setSubmitting }) => {
          const data = { memo: values?.description };

          try {
            const token = await getAccessTokenSilently();
            await PastoralService.updateEvent({
              data,
              token,
              eventId: eventId,
            });
            toastr.success(
              "Success",
              `Event Description Changed Successfully!`
            );
            refetchEventCallback();
            onClose();
          } catch (error) {
            toastr.error(
              "Error",
              error?.data?.message || "Something went wrong!"
            );
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <DialogContent style={{ paddingTop: 0 }}>
              <Field
                as="textarea"
                name="description"
                className="form-control mt-2"
                rows={4}
                placeholder="Enter event description"
              />
              <ErrorMessage
                name="description"
                component="div"
                className="text-danger mt-1 fs-12"
              />
            </DialogContent>

            <DialogActions
              style={{ marginTop: 10, paddingRight: 23, marginBottom: 15 }}
            >
              <MyButton
                type="secondary"
                content="Close"
                onClick={onClose}
                disabled={isSubmitting}
              />
              <MyButton
                type="primary"
                content={
                  isSubmitting ? (
                    <CircularProgress size={18} style={{ color: "#fff" }} />
                  ) : (
                    "Save"
                  )
                }
                variant="outlined"
                disabled={isSubmitting}
                style={{
                  minWidth: 103,
                  height: 45,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditEventDescriptionModal;
